import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-card-modal',
  templateUrl: './confirmation-card-modal.component.html',
  styleUrls: ['./confirmation-card-modal.component.scss']
})
export class ConfirmationCardModalComponent {

  @Input() showPopup: boolean;
  @Input() showCancelButton: boolean;
  @Input() showSubmitButton: boolean;
  @Input() banner: string;
  @Input() heading: string;
  @Input() paragraph: string;
  @Input() cancelText: string;
  @Input() submitText: string;
  @Output() modalAction: EventEmitter<boolean> = new EventEmitter();

  public modalActionFunction(action: boolean): void {
    this.modalAction.emit(action);
  }
}
